import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

// صفحات العميل
import ClientDashboard from './pages/ClientDashboard';
import ArchivePage from './pages/ArchivePage';
import PublicSignUp from './pages/PublicSignUp';
import LoginPage from './pages/LoginPage';
import LandingPage from './pages/LandingPage';
import NewsPage from './pages/NewsPage';
import VideosPage from './pages/VideosPage';
import NotificationsPage from './pages/NotificationsPage';
import NewsDetailsPage from './pages/NewsDetailsPage';
import VideoDetailsPage from './pages/VideoDetailsPage';
import AdminAdsPage from './pages/AdminAdsPage';

// صفحات الإدارة
import ManualSignals from './pages/ManualSignals';
import AnalystDashboard from './pages/AnalystDashboard';
import AdminDashboard from './pages/AdminDashboard';
import SignalDetailsPage from './pages/SignalDetailsPage';
import AdminClientsPage from './pages/AdminClientsPage';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();

// مكون لتوجيه الجذر
const RootRedirect = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // العميل المسجّل → لوحة التحكم
        navigate('/dashboard');
      } else {
        // الزائر → صفحة الاستقبال
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  return <LandingPage />;
};

// مكون لحماية الصفحات الخاصة
const ProtectedRoute = ({ children, allowedRoles = ['user', 'analyst', 'admin'] }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            const userRole = userData.role || 'pending';
            
            // ✅ التحقق من صلاحية الجلسة
            const sessionDoc = await getDoc(doc(db, 'user_sessions', currentUser.uid));
            const currentSessionId = currentUser.refreshToken;
            
            if (sessionDoc.exists()) {
              const activeSession = sessionDoc.data().active_session_id;
              
              // إذا كانت الجلسة غير مطابقة → خروج تلقائي
              if (activeSession && activeSession !== currentSessionId) {
                await auth.signOut();
                navigate('/login');
                setLoading(false);
                return;
              }
            }
            
            if (allowedRoles.includes(userRole)) {
              setUser({ ...currentUser, role: userRole });
            } else {
              navigate('/login');
            }
          } else {
            navigate('/login');
          }
        } catch (error) {
          console.error("Error fetching user ", error);
          navigate('/login');
        }
      } else {
        navigate('/login');
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  return children;
};

// مكون شريط التنقل
const Navigation = ({ userRole }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const handleLogout = () => {
    auth.signOut();
    setMenuOpen(false);
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav style={{ 
      backgroundColor: '#1e40af', 
      padding: '12px 16px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px'
      }}>
        <div style={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}>
          TradeAH V2
        </div>
        
        {/* زر القائمة للهواتف */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            display: window.innerWidth <= 768 ? 'flex' : 'none',
            backgroundColor: 'rgba(255,255,255,0.2)',
            border: 'none',
            width: '36px',
            height: '36px',
            borderRadius: '6px',
            cursor: 'pointer',
            color: 'white',
            fontSize: '20px',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          ☰
        </button>
        
        {/* قائمة التنقل - تظهر دائمًا على الكبيوتر، وحسب الحالة على الموبايل */}
        <div 
          style={{
            display: window.innerWidth <= 768 
              ? (menuOpen ? 'flex' : 'none') 
              : 'flex',
            gap: '8px',
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            ...(window.innerWidth <= 768 && menuOpen && {
              position: 'absolute',
              top: '50px',
              right: '16px',
              backgroundColor: '#1e40af',
              borderRadius: '8px',
              padding: '8px',
              boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
              zIndex: 1000,
              flexDirection: 'column',
              minWidth: '160px'
            })
          }}
        >
          <Link 
            to="/dashboard" 
            style={{ 
              color: 'white', 
              textDecoration: 'none', 
              padding: '6px 12px',
              borderRadius: '6px',
              backgroundColor: 'rgba(255,255,255,0.2)',
              fontSize: '13px',
              whiteSpace: 'nowrap'
            }}
            onClick={handleLinkClick}
          >
            Dashboard
          </Link>
          <Link 
            to="/archive" 
            style={{ 
              color: 'white', 
              textDecoration: 'none', 
              padding: '6px 12px',
              borderRadius: '6px',
              backgroundColor: 'rgba(255,255,255,0.2)',
              fontSize: '13px',
              whiteSpace: 'nowrap'
            }}
            onClick={handleLinkClick}
          >
            Archive
          </Link>
          
          <Link 
            to="/news" 
            style={{ 
              color: 'white', 
              textDecoration: 'none', 
              padding: '6px 12px',
              borderRadius: '6px',
              backgroundColor: 'rgba(255,255,255,0.2)',
              fontSize: '13px',
              whiteSpace: 'nowrap'
            }}
            onClick={handleLinkClick}
          >
            الأخبار
          </Link>
          <Link 
            to="/videos" 
            style={{ 
              color: 'white', 
              textDecoration: 'none', 
              padding: '6px 12px',
              borderRadius: '6px',
              backgroundColor: 'rgba(255,255,255,0.2)',
              fontSize: '13px',
              whiteSpace: 'nowrap'
            }}
            onClick={handleLinkClick}
          >
            الفيديوهات
          </Link>       
          <Link 
            to="/notifications" 
            style={{ 
              color: 'white', 
              textDecoration: 'none', 
              padding: '6px 12px',
              borderRadius: '6px',
              backgroundColor: 'rgba(255,255,255,0.2)',
              fontSize: '13px',
              whiteSpace: 'nowrap'
            }}
            onClick={handleLinkClick}
          >
            الإشعارات
          </Link>     
          
          {userRole === 'analyst' && (
            <Link 
              to="/manual" 
              style={{ 
                color: 'white', 
                textDecoration: 'none', 
                padding: '6px 12px',
                borderRadius: '6px',
                backgroundColor: 'rgba(255,255,255,0.2)',
                fontSize: '13px',
                whiteSpace: 'nowrap'
              }}
              onClick={handleLinkClick}
            >
              إدخال توصية
            </Link>
          )}
          
          {userRole === 'admin' && (
            <>
              <Link 
                to="/analyst" 
                style={{ 
                  color: 'white', 
                  textDecoration: 'none', 
                  padding: '6px 12px',
                  borderRadius: '6px',
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  fontSize: '13px',
                  whiteSpace: 'nowrap'
                }}
                onClick={handleLinkClick}
              >
                إدارة المحللين
              </Link>
              <Link 
                to="/admin/clients" 
                style={{ 
                  color: 'white', 
                  textDecoration: 'none', 
                  padding: '6px 12px',
                  borderRadius: '6px',
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  fontSize: '13px',
                  whiteSpace: 'nowrap'
                }}
                onClick={handleLinkClick}
              >
                إدارة العملاء
              </Link>
                            <Link 
                to="/admin/ads" 
                style={{ 
                  color: 'white', 
                  textDecoration: 'none', 
                  padding: '6px 12px',
                  borderRadius: '6px',
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  fontSize: '13px',
                  whiteSpace: 'nowrap'
                }}
                onClick={handleLinkClick}
              >
                إدارة الاعلانات
              </Link>
              <Link 
                to="/admin" 
                style={{ 
                  color: 'white', 
                  textDecoration: 'none', 
                  padding: '6px 12px',
                  borderRadius: '6px',
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  fontSize: '13px',
                  whiteSpace: 'nowrap'
                }}
                onClick={handleLinkClick}
              >
                لوحة التحكم
              </Link>
            </>
          )}
          
          <button 
            onClick={handleLogout}
            style={{
              color: 'white',
              background: 'none',
              border: 'none',
              padding: '6px 12px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '13px'
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};
// مكون الصفحة الرئيسية مع التنقل
const MainApp = () => {
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            let role = 'user';
            
            if (userData.role === 'pending' && userData.trial_status === 'active') {
              role = 'user';
            } else if (userData.role) {
              role = userData.role;
            }
            
            setUserRole(role);
          } else {
            setUserRole('user');
          }
        } catch (error) {
          console.error("Error in MainApp:", error);
          setUserRole('user');
        }
      } else {
        setUserRole(null);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  return (
    <>
      {userRole && <Navigation userRole={userRole} />}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
        <Routes>
          {/* الصفحة الرئيسية */}
          <Route path="/" element={<RootRedirect />} />
          
          {/* الصفحات المحمية */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute allowedRoles={['user', 'analyst', 'admin']}>
                <ClientDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/archive" 
            element={
              <ProtectedRoute allowedRoles={['user', 'analyst', 'admin']}>
                <ArchivePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/manual" 
            element={
              <ProtectedRoute allowedRoles={['analyst', 'admin']}>
                <ManualSignals />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/analyst" 
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AnalystDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/clients" 
            element={
               <ProtectedRoute allowedRoles={['admin']}>
                 <AdminClientsPage />
                 </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            } 
             />
            {/* ... المسارات الأخرى ... */}
          <Route 
            path="/news" 
             element={
              <ProtectedRoute allowedRoles={['user', 'analyst', 'admin']}>
              <NewsPage />
              </ProtectedRoute>
            } 
           />
          <Route 
           path="/videos" 
           element={
           <ProtectedRoute allowedRoles={['user', 'analyst', 'admin']}>
           <VideosPage />
            </ProtectedRoute>
            } 
          />
         <Route 
         path="/notifications" 
         element={
        <ProtectedRoute allowedRoles={['user', 'analyst', 'admin']}>
        <NotificationsPage />
         </ProtectedRoute>
        } 
        />
        <Route 
          path="/admin/ads" 
          element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminAdsPage />
              </ProtectedRoute>
             } 

 
          />
          <Route path="/signal/:id" element={<SignalDetailsPage />} />
          
          {/* الصفحات العامة */}
          <Route path="/signup" element={<PublicSignUp />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/news/:id" element={<NewsDetailsPage />} />
           <Route path="/videos/:id" element={<VideoDetailsPage />} />
        </Routes>
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <div style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
        <MainApp />
      </div>
    </Router>
  );
}

export default App;